var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Transition',{attrs:{"appear":"","name":"fade"}},[_c('div',{staticClass:"notification"},[_c('div',{staticClass:"content"},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2),(_vm.$slots.footer)?_c('footer',[_vm._t("footer")],2):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }